/*
  화이트리스트 — 운영자(스튜디오 소유자) 이메일.
  현재는 단일 이메일만 로그인이 허용되며, 그 외 계정은 onAuthStateChanged
  에서 즉시 로그아웃 처리됨. 의뢰자는 별도 비밀번호 기반 /manage/:slug 패널을 사용.
*/
export const ADMIN_EMAILS = ['bhwoo48@gmail.com'] as const;

export function isAdminEmail(email?: string | null): boolean {
  if (!email) return false;
  return (ADMIN_EMAILS as readonly string[]).includes(email.toLowerCase());
}

/** 운영자(어드민) 단일 이메일 — UI 메시지/이메일 발송 등에 사용 */
export const PRIMARY_ADMIN = ADMIN_EMAILS[0];
